import fetch from '../utils/fetch'

export function getTradeList(query) {
return fetch({
url: '/trade',
method: 'get',
params: query
})
}

export function setPaymentSetting(query) {
return fetch({
url: '/trade/payment/setting',
method: 'post',
data: query
})
}

export function getPaymentSetting(query) {
return fetch({
url: '/trade/payment/setting',
method: 'get',
params: query
})
}

export function getOrderList(query) {
return fetch({
url: '/orders',
method: 'get',
params: query
})
}

export function getRightsList(query) {
return fetch({
url: '/rights/getdata',
method: 'get',
params: query
})
}

export function findRightsList(query) {
return fetch({
url: '/rights/list',
method: 'get',
params: query
})
}

export function createRights(query) {
return fetch({
url: '/rights',
method: 'post',
data: query
})
}

export function getOrderDetail(orderId) {
return fetch({
url: '/order/' + orderId,
method: 'get'
})
}

export function deleteNp(orderId) {
    return fetch({
        url: '/order/deleteNP/' + orderId,
        method: 'get'
    })
}

export function getOrderDrugDetail(orderId) {
    return fetch({
        url: '/order/drug/' + orderId,
        method: 'get'
    })
}

export function handleAb(orderId) {
    return fetch({
        url: '/order/handleAb/' + orderId,
        method: 'get'
    })
}

export function pushOrder(orderId) {
    return fetch({
        url: '/order/push/' + orderId,
        method: 'get'
    })
}

export function pushOrderMt(orderId) {
    return fetch({
        url: '/order/meituan/' + orderId,
        method: 'get'
    })
}

export function pushOrderPt(orderId) {
    return fetch({
        url: '/order/pushpaotui/' + orderId,
        method: 'get'
    })
}

export function pushOrderFn(orderId) {
    return fetch({
        url: '/order/fengniao/' + orderId,
        method: 'get'
    })
}

export function pushOrderYx (orderId) {
  return fetch({
    url:'/order/push/yx/' + orderId,
    method:'get'
  })
}

// 补推会员中台（付费会员订单）
export function pushOrderToMemCenter (orderId) {
  return fetch({
    url: '/order/pushMemCenter/' + orderId,
    method: 'get'
  })
}

export function getRightsLogList(query) {
return fetch({
url: '/rights/log',
method: 'get',
params: query
})
}

export function exportList(query) {
return fetch({
url: '/rights/logExport',
method: 'get',
params: query,
})
}

export function delayRights(query) {
return fetch({
url: '/rights/delay',
method: 'post',
data: query
})
}

export function transferRights(query) {
  return fetch({
    url: '/transfer/rights',
    method: 'put',
    params: query
  })
}

export function transferRightsList(query) {
  return fetch({
    url: '/transfer/rights/list',
    method: 'get',
    params: query
  })
}

export function getRightsInfo(query) {
return fetch({
url: '/rights/info',
method: 'get',
params: query,
})
}

export function delivery(query) {
  return fetch({
    url: '/delivery',
    method: 'post',
    data: query
  })
}

export function redelivery(query) {
  return fetch({
    url: '/redelivery',
    method: 'post',
    data: query
  })
}

export function updateDelivery(order_id, query) {
  return fetch({
    url: '/delivery/' + order_id,
    method: 'put',
    data: query
  })
}

export function orderExport(query) {
  return fetch({
    url: '/orders/exportdata',
    method: 'get',
    params: query,
  })
}

export function orderNormalExport(query) {
  return fetch({
    url: '/orders/exportnormaldata',
    method: 'get',
    params: query,
  })
}

export function rightsExport(query) {
  return fetch({
    url: '/rights/exportdata',
    method: 'get',
    params: query,
  })
}

export function getPaymentList() {
  return fetch({
    url: '/trade/payment/list',
    method: 'get'
  })
}

export function tradeExport(query) {
  return fetch({
    url: '/trades/exportdata',
    method: 'get',
    params: query,
  })
}

export function ExportLogList(query) {
  return fetch({
    url: '/espier/exportlog/list',
    method: 'get',
    params: query,
  })
}

export function getOrderSetting(query) {
  return fetch({
    url: '/orders/setting/get',
    method: 'get',
    params: query,
  })
}

export function setOrderSetting(query) {
  return fetch({
    url: '/orders/setting/set',
    method: 'post',
    data: query,
  })
}

export function getCancelOrderInfo(order_id, query) {
  return fetch({
    url: '/order/'+order_id+'/cancelinfo',
    method: 'get',
    params: query
  })
}

export function getDoneOrderInfo(query) {
    return fetch({
        url: '/order/confirmReceiptbyAdmin',
        method: 'post',
        params: query
    })
}

export function processDrugOrders(order_id, query) {
  return fetch({
    url: '/order/'+order_id+'/processdrug',
    method: 'put',
    data: query
  })
}

export function cancelConfirm(order_id, query) {
  return fetch({
    url: '/order/'+order_id+'/confirmcancel',
    method: 'post',
    data: query
  })
}

export function addRemarkConfirm( query) {
  return fetch({
    url: '/order/updateAdminRemarks',
    method: 'post',
    data: query
  })
}

export function cancelOrderConfirm(order_id, query) {
    return fetch({
        url: '/order/'+order_id+'/cancel',
        method: 'post',
        data: query
    })
}

export function confirmCorporatePay(order_id, data) {
  return fetch({
    url: '/order/' + order_id + '/confirmCorporatePay',
    method: 'post',
    data
  })
}

export function rejectCorporatePay(order_id, data) {
  return fetch({
    url: '/order/' + order_id + '/rejectCorporatePay',
    method: 'post',
    data
  })
}
export function OmsQueueLogList(query) {
  return fetch({
    url: '/omsqueuelog',
    method: 'get',
    params: query
  })
}

export function getCartMarketingAd(query) {
  return fetch({
    url: '/orders/cartad/get',
    method: 'get',
    params: query,
  })
}

export function setCartMarketingAd(query) {
  return fetch({
    url: '/orders/cartad/set',
    method: 'post',
    data: query,
  })
}

export function getLogisticsList () {
  return fetch({
    url: '/trade/logistics/list',
    method: 'get'
  })
}

export function setKdniaoSetting (query) {
  return fetch({
    url: '/trade/kuaidi/setting',
    method: 'post',
    data: query
  })
}

export function getKdniaoSetting (query) {
  return fetch({
    url: '/trade/kuaidi/setting',
    method: 'get',
    params: query
  })
}

export function getDeliveryDetail (query) {
  return fetch({
    url: '/delivery/details',
    method: 'get',
    params: query
  })
}

export function getRefundErrorLogsList (query) {
  return fetch({
    url: '/trade/refunderrorlogs/list',
    method: 'get',
    params: query
  })
}
export function getTradeRateList (query) {
  return fetch({
    url: '/trade/rate',
    method: 'get',
    params: query
  })
}

export function refundResubmit (id) {
  return fetch({
    url: '/trade/refunderrorlogs/resubmit/' + id,
    method: 'put'
  })
}

export function replyTradeRate (query) {
  return fetch({
    url: '/trade/rate',
    method: 'put',
    params: query
  })
}

export function getTradeRateDetails (rate_id) {
  return fetch({
    url: '/trade/'+rate_id+'/rate',
    method: 'get'
  })
}

export function deleteRate (id) {
  return fetch({
    url: '/trade/rate/'+id,
    method: 'delete'
  })
}

export function isBind () {
  return fetch({
    url: '/third/saascert/isbind',
    method: 'get'
  })
}

export function refundGoods(orderId) {
    return fetch({
        url: '/order/refundGoods/' + orderId,
        method: 'get'
    })
}

export function getStatementlist(query) {
    return fetch({
        url:'/statement/statmentlist',
        method:'get',
        params:query
    })
}

export function statementExport(query) {
    return fetch({
        url: '/statement/exportdata',
        method: 'get',
        params: query,
    })
}

export function getShengyibaoNetStatus (query) {
  return fetch({
    url: 'order/shengyibao/netstatus',
    method: 'get',
    params: query
  })
}

export function getShengyibaoMemberTrades (query) {
  return fetch({
    url: 'order/shengyibao/trades',
    method: 'get',
    params: query
  })
}

export function getShengyibaoMemberInfo (query) {
  return fetch({
    url: 'order/shengyibao/memberinfo',
    method: 'post',
    data: query
  })
}
export function getFindList(query) {
    return fetch({
        url: '/finddrug/list',
        method: 'get',
        params:query,
    })
}

export function getFindExport(query) {
    return fetch({
        url: '/finddrug/export',
        method: 'get',
        params:query,
    })
}

export function getFindUpdate(query) {
    return fetch({
        url: '/finddrug/update',
        method: 'get',
        params: query,
    })
}
// 代客找药备注
export function addMsg (query) {
  return fetch({
    url: '/finddrug/add_msg',
    method: 'post',
    data: query
  })
}
// 代客找药备注
export function getMsgList (query) {
  return fetch({
    url: '/finddrug/get_msg_list',
    method: 'get',
    params: query
  })
}
//燕尾帽订单列表
export function getYwmddList(query) {
  return fetch({
      url: '/ywmdd/list',
      method: 'get',
      params:query,
  })
}
//燕尾帽订单导出
export function getYwmddExport(query) {
  return fetch({
      url: '/ywmdd/export',
      method: 'get',
      params:query,
  })
}
//更新燕尾帽
export function getYwmddUpdate(query) {
  return fetch({
      url: '/ywmdd/update',
      method: 'get',
      params: query,
  })
}
// 燕尾帽订单状态
export function getYwmStatusList (query) {
return fetch({
  url: '/ywmdd/get_msg_list',
  method: 'get',
  params: query
})
}
//订单补发
export function orderPayRetroactively (query) {
  return fetch({
    url: '/finddrug/add_msg',
    method: 'post',
    data: query
  })
}

export function getPayStatus (query) {
  return fetch({
    url: '/allinpay/getOrderStatus',
    method: 'get',
    params: query
  })
}

export function getOmsSendOrderLocation (query) {
  return fetch({
    url: '/orders/oms/sendorder/location',
    method: 'post',
    data: query
  })
}

export function pushExpressOrder2Oms (query) {
  return fetch({
    url: '/order/send/express',
    method: 'get',
    params: query
  })
}

// ----------第三方
export function getThirdList(query) {
  return fetch({
    url: '/orders/ThirdMiniprogramJump/getList',
    method: 'get',
    params: query
  })
}
export function ThirdJumpExport (query) {
  return fetch({
    url: '/orders/ThirdMiniprogramJump/export',
    method: 'get',
    params: query
  })
}

export function getMonthUrlLog (query) {
  return fetch({
    url: '/orders/ordermonthurllog',
    method: 'get',
    params: query
  })
}

export function downloadFile (query) {
  return fetch({
    url: '/d/ordermonthurllog',
    method: 'get',
    params: query
  })
}

// 上传文件
export function handleUploadFile (params) {
  return fetch({
    url: '/orders/account/uploadCheckFile',
    method: 'post',
    data: params
  })
}

export function getPayTypeList (params) {
  return fetch({
    url: '/orders/account/gettype',
    method: 'post',
    data: params
  })
}

//文件比对
export function checkFileSubmit (params) {
  return fetch({
    url: '/orders/account/check',
    method: 'post',
    data: params
  })
}
//文件移除
export function removeFileRow (params) {
  return fetch({
    url: '/orders/account/removeRow',
    method: 'post',
    data: params
  })
}

export function getCheckFileList (params) {
  return fetch({
    url: '/orders/account/getCheckFileList',
    method: 'post',
    data: params
  })
}

export function checkInsert (params) {
  return fetch({
    url: '/orders/account/insert',
    method: 'post',
    data: params
  })
}

export function updatePreOrder (params) {
  return fetch({
    url: '/orders/updatePreOrder',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/trade.js